export default "__VITE_ASSET__D7VkGe4x__"